import React, { Component } from "react";

export default class Inicio extends Component {

	render() {

		return (
			<>

				<div className="clearfix" style={{ clear: "both" }}></div>
				<div id="home" className="hero-section">
					<div className="container">
						<div className="row align-items-center">
							<div className="col-md-6">
								<div className="hero-content">
									<div className="hero-title">
										<h1 className="hero-title">Send Stables</h1>
										<h1 className="hero">no TRX needed.</h1>
									</div>
									<div className="hero-text">
										<p>Cirotrx allows users to send stablecoins on the Tron blockchain <br />without requiring TRX or energy in their wallet,<br />providing more accessible and straightforward transactions.</p>
									</div>
									<div className="hero-button">
										<a href="?dapp">Connect to the dApp</a>
									</div>
								</div>
							</div>
							<div className="col-md-6">
								<div className="dreamit-hero-thumb">
									<div className="hero-main-thumb">
										<img src="assets/images/slider/tronlink.png" alt="" />
									</div>
									<div className="hero-thumb-inner1 bounce-animate4">
										<img src="assets/images/slider/usdttranslucido.png" alt="" />
									</div>
									<div className="hero-thumb-inner2 bounce-animate">
										<img src="assets/images/slider/usdctranslucido.png" alt="" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="clearfix" style={{ clear: "both" }}></div>

				<div id="what" className="about-area pt-100 pb-100">
					<div className="container">
						<div className="row">
							<div className="col-lg-6 col-md-6 col-sm-12">
								<div className="dreamit-about-thumb">
									<img src="assets/images/resource/ciroesquema.png" alt="" />
								</div>
							</div>
							<div className="col-lg-6 col-md-6 col-sm-12">
								<div className="dreamit-section-title pb-5">
									<h4>What is Cirotrx?</h4>
									<h1>Simplifying stablecoin transactions on Tron.</h1>
									<p className="section-text">Cirotrx is a solution designed to facilitate stablecoin transactions on the Tron blockchain, removing the need to worry about energy costs or having TRX in the user's wallet. Created, developed, and powered by Brutus.Finance, Cirotrx uses a smart contract to manage the energy required for stablecoin transactions, allowing users to make sends using only the bandwidth provided by default by the Tron network.</p>
									<p>This simplifies cryptocurrency transactions, making the sending of stablecoins a more accessible and uncomplicated process for all users, from beginners to experienced blockchain operators.</p>
								</div>
								<div className="hero-button">
									<a href="?dapp">Connect to the dApp</a>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div id="about" className="team-area pt-100 pb-55">
					<div className="container">
						<div className="row">
							<div className="dreamit-section-title text-center up pb-30">
								<h4>Our Team</h4>
								<h1>Expert <span>Team</span></h1>
								<p className="section-text">The team behind Brutus.Finance, creators of Cirotrx, are passionate blockchain and decentralized finance experts, dedicated to simplifying and securing your stablecoin transactions on the Tron blockchain with top-tier innovation and technical expertise.</p>
							</div>
						</div>
						<div className="row">
							<div className="col-lg-3 col-md-6 col-sm-12">
								<div className="team-single-box">
									<div className="team-box-inner">
										<div className="team-thumb">
											<img src="assets/images/resource/steven.png" alt="" />
										</div>
										<div className="team-content">
											<div className="team-title">
												<h3>Steven_Stc</h3>
											</div>
											<div className="team-text">
												<p>Technical Lead</p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-3 col-md-6 col-sm-12">
								<div className="team-single-box upper1">
									<div className="team-box-inner">
										<div className="team-thumb">
											<img src="assets/images/resource/Dalirium.png" alt="" />
										</div>
										<div className="team-content">
											<div className="team-title">
												<h3>DaLlRiUm</h3>
											</div>
											<div className="team-text">
												<p>Product Manager</p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-3 col-md-6 col-sm-12">
								<div className="team-single-box upper2">
									<div className="team-box-inner">
										<div className="team-thumb">
											<img src="assets/images/resource/Vicen.png" alt="" />
										</div>
										<div className="team-content">
											<div className="team-title">
												<h3>NiresVicente</h3>
											</div>
											<div className="team-text">
												<p>Operations Lead</p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-3 col-md-6 col-sm-12">
								<div className="team-single-box upper3">
									<div className="team-box-inner">
										<div className="team-thumb">
											<img src="assets/images/resource/Deiiva.png" alt="" />
										</div>
										<div className="team-content">
											<div className="team-title">
												<h3>Deiiva</h3>
											</div>
											<div className="team-text">
												<p>Technical Lead</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div id="contact" className="contact-form-area pt-3 pb-100">
					<div className="container">
						<div className="row">
							<div className="dreamit-section-title text-center up pb-40">
								<h4>Contact</h4>
								<h1>Contact <span>with Us</span></h1>
								<p className="section-text">At Cirotrx, powered by Brutus.Finance, your experience matters to us. Whether you have inquiries, feedback, or encounter any issues, our dedicated team is here to assist you. Navigating through the world of decentralized finance should be smooth, and we're here to ensure that your journey with us is seamless.</p>
							</div>
						</div>
						<div className="row">
							<div className="col-lg-4 col-md-6 col-sm-12">
								<div className="contact-icon-box">
									<div className="contact-icon-thumb">
										<img src="assets/images/resource/contact1.png" alt="" />
									</div>
									<div className="contact-text">
										<p>admin@cirotrx.com</p>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6  col-sm-12">
								<div className="contact-icon-box">
									<div className="contact-icon-thumb">
										<img src="assets/images/resource/" alt="" />
									</div>
									<div className="">
										<p></p>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6  col-sm-12">
								<a target="_blank" rel="noopener noreferrer" href="https://t.me/+M02lMfuL6mBlZWI0">
									<div className="contact-icon-box">
										<div className="contact-icon-thumb">
											<img src="assets/images/resource/contact3.png" alt="" />
										</div>
										<div className="contact-text">
											<p>Join us on Telegram</p>
										</div>
									</div></a>
							</div>
						</div>
					</div>
				</div>


			</>
		);
	}
}
